<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.notice-main-title-div {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}

.eye {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 20%;
  }
}

.count-list {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 60px;
  margin-top: 24px;

  .list-item {
    width: calc((100% / 3) - 100px);
    border: 1px solid #999;
    border-radius: 8px;
    padding: 16px 0;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

    .item-num {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-bottom: 16px;

      span {
        font-size: 32px;
        color: #333;
        margin-right: 16px;
      }
    }

    .item-text {
      font-size: 14px;
      color: #999;
      text-align: center;
    }

  }


}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">总服务账单列表</div>
      <div class="count-list">
        <div class="list-item">
          <div class="item-num"><span>{{statisInfo.totalChargeOrder || '0' }}</span> 笔</div>
          <div class="item-text">累计活动桩充电订单数</div>
        </div>
        <div class="list-item">
          <div class="item-num"><span>{{statisInfo.serviceBillCount || '0' }}</span> 笔</div>
          <div class="item-text">累计活动桩服务账单数</div>
        </div>
      </div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="
          () => {
            showMultiQuerys = !showMultiQuerys;
          }
        ">
          高级筛选
        </button>
        <button class="common-bg-button" @click="toExportList()">
          导 出
        </button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small" placeholder="请输入订单编号/用户手机/用户姓名/支付流水号" />
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">账单状态</p>
              <el-select v-model="queryInfo.orderPayStatus" size="small" clearable class="full-width"
                placeholder="请选择账单状态">
                <el-option label="已支付" value="CHARGE_BACKS" />
                <el-option label="已逾期" value="CHARGE_LATE" />
                <el-option label="已退款" value="CHARGE_REFUND" />
                <el-option label="待守约" value="CHARGE_COMPLIANCE" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">支付结果</p>
              <el-select v-model="queryInfo.orderPayResult" size="small" clearable class="full-width"
                placeholder="请选择支付结果">
                <el-option label="支付成功" value="PAID_SUCCESS" />
                <el-option label="支付失败" value="PAID_FAIL" />
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单创建时间</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.createFromTime" type="datetime" size="small"
                  prefix-icon="el-icon-date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" class="flex-1" />
                <span class="time-query-line" style="line-height: 32px">-</span>
                <el-date-picker v-model="queryInfo.createToTime" type="datetime" size="small" prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" class="flex-1" />
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单类型</p>
              <el-select v-model="queryInfo.recordOrderType" size="small" clearable class="full-width"
                placeholder="请选择订单类型">
                <el-option label="正常充电订单" value="COMMON_CHARGE_ORDER" />
                <el-option label="私桩共享订单" value="SHARE_CHARGE_ORDER" />
                <el-option label="服务费违约订单" value="SERVICE_DEFAULT_FEE" />
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="query-flex-btns-div margin-bottom-16">
          <button class="common-bg-button" @click="getListData(pagination, true)">
            搜 索
          </button>
          <button class="common-bg-button" @click="resetQuery()">
            重 置
          </button>
        </div>
      </div>

      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" style="width: 100%" border stripe>
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column prop="transactionId" label="支付流水号" width="240" align="center" fixed="left" />
          <el-table-column prop="pileOrderNo" label="充电订单编号" width="200" align="center" />
          <el-table-column prop="outTradeNo" label="商户订单编号" width="200" align="center" />
          <el-table-column prop="pileCode" label="充电桩编号" width="200" align="center" />
          <el-table-column prop="pileAssetCode" label="充电桩资产编号" width="200" align="center" />
          <el-table-column prop="recordOrderType" label="订单类型" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.recordOrderType == 'COMMON_CHARGE_ORDER'">正常充电订单</span>
              <span v-if="scope.row.recordOrderType == 'SHARE_CHARGE_ORDER'">私桩共享订单</span>
              <span v-if="scope.row.recordOrderType == 'SERVICE_DEFAULT_FEE'">服务费违约订单</span>
            </template>
          </el-table-column>
          <el-table-column prop="custName" label="用户姓名" width="200" align="center" />
          <el-table-column prop="custMobile" label="" width="200" align="center" fixed="left" :key="Math.random()">
            <div slot="header" style="
                display: flex;
                align-items: center;
                justify-content: center;
              ">
              <span style="margin-right: 8px">用户手机号</span>
              <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_隐藏.png" alt=""
                v-if="!isFlag" @click="flagChange()" />
              <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_显示.png" alt="" v-if="isFlag"
                @click="flagChange()" />
            </div>
            <template slot-scope="scope">
              <span v-if="isFlag">{{ scope.row.custMobile }}</span>
              <span v-else>{{
                scope.row.custMobile
                  ? scope.row.custMobile.replace(
                    scope.row.custMobile.substring(2, 9),
                    "*******"
                  )
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="province" label="省" width="200" align="center" />
          <el-table-column prop="city" label="市" width="200" align="center" />
          <el-table-column prop="area" label="区" width="200" align="center" />
          <el-table-column prop="address" label="详细地址" width="200" align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="200" trigger="hover" :disabled="scope.row.address.length <= 10">
                <div>{{ scope.row.address }}</div>
                <span slot="reference" v-if="scope.row.address.length <= 10">{{ scope.row.address }}</span>
                <span slot="reference" v-if="scope.row.address.length > 10">{{ scope.row.address.substr(0, 10) + "..."
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="withHoldType" label="代扣费用类型" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.withHoldType == 'BASIC_SERVICE'">
                基础服务费</span>
              <span v-if="scope.row.withHoldType == 'TECHNICAL_SERVICE'">
                技术服务费</span>
            </template>
          </el-table-column>
          <el-table-column prop="serviceFeePrice" label="服务费价格" width="200" align="center" />
          <el-table-column prop="chargeVal" label="充电电量" width="200" align="center" />
          <el-table-column prop="beginTime" label="充电开始时间" width="200" align="center" />
          <el-table-column prop="endTime" label="充电结束时间" width="200" align="center" />
          <el-table-column prop="feePayAmount" label="应收服务费" width="200" align="center" />
          <el-table-column prop="actPayAmount" label="平台实收服务费" width="200" align="center" />
          <el-table-column prop="walletListUserAmount" label="用户实付服务费" width="200" align="center" />
          <el-table-column prop="walletListDiscountAmount" label="支付宝折扣服务费" width="200" align="center" />
          <el-table-column prop="refundAmount" label="已退平台实收服务费" width="200" align="center" />
          <el-table-column prop="useRefundAmount" label="已退用户实付服务费" width="200" align="center" />
          <el-table-column prop="discountRefundAmount" label="已退支付宝折扣服务费" width="200" align="center" />
          <el-table-column prop="payHandlingFee" label="支付手续费" width="200" align="center" />
          <el-table-column prop="orderPayStatus" label="账单状态" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderPayStatus == 'CHARGE_BACKS'">已支付</span>
              <span v-if="scope.row.orderPayStatus == 'CHARGE_REFUND'">已退款</span>
              <span v-if="scope.row.orderPayStatus == 'CHARGE_LATE'">已逾期</span>
              <span v-if="scope.row.orderPayStatus == 'CHARGE_COMPLIANCE'">待守约</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderPayFunction" label="支付方式" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderPayFunction == 'SESAME_PLATFORM_WITH_HOLD'">商家代扣</span>
            </template>
          </el-table-column>
          <el-table-column prop="payTime" label="支付完成时间" width="200" align="center" />
          <el-table-column prop="orderPayResult" label="支付结果" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderPayResult == 'PAID_SUCCESS'">支付成功</span>
              <span v-if="scope.row.orderPayResult == 'PAID_FAIL'">支付失败</span>
            </template>
          </el-table-column>

          <el-table-column prop="createdWhen" label="订单创建时间" width="200" align="center" />
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>

    <!-- 退款编辑 -->
    <el-dialog title="退款编辑" width="520px" :visible.sync="showRtOrderDialog">
      <el-form :model="rtOrderFormInfo" ref="userRfForm" :rules="rtOrderFormRules">
        <el-form-item label="退款流水号" prop="transactionNo">
          <el-input clearable v-model="rtOrderFormInfo.transactionNo" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRtOrderForm('userRfForm')" size="small">提 交</el-button>
        <el-button @click="showRtOrderDialog = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      isFlag: false,
      tableData: [], // 表格数据
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuerys: false,
      orderStatusList: [],

      showRtOrderDialog: false,
      rtOrderFormInfo: {},
      rtOrderFormRules: {},
      statisInfo: {},
    };
  },
  methods: {
    flagChange() {
      this.isFlag = !this.isFlag;
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      // 获取表格数据
      _.$H
        .post(_, _.$A.activityOrder.serviceBillList, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });

        // 获取统计
        _.$H
        .post(_, _.$A.activityOrder.serviceBillCount, {
          createFromTime:_.queryInfo.createFromTime,
          createToTime:_.queryInfo.createToTime,
        })
        .then((res) => {
          console.log(res)
          _.statisInfo = res.data.data
        });
    },
    // 导出
    toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      // if (process.env.NODE_ENV == 'development') {
      //   urls = 'http://192.168.8.174:7997'
      // } else {
      //   urls = 'http://ocharge.shzhida.com:6777'
      // }
      _.$H
        .post(_, _.$A.activityOrder.serviceBillListExcel, _.queryInfo)
        .then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = urls + res.data.data.filePath;
          window.open(downUrl, "_blank");
          _.$U.hideLoading(_);
        });
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        keyWord: undefined, // 关键字
        orderPayStatus: undefined, // 账单状态
        orderPayResult: undefined, // 支付结果
        recordOrderType: undefined, // 订单类型
        createFromTime: undefined, // 订单创建时间
        createToTime: undefined, // 订单创建时间
      };
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
};
</script>
